import { useTheme } from 'styled-components';

import Tooltip from '~components/common/Tooltip';
import ExclamationMark from '~components/Icon/ExclamationMark';
import CompanySectionTitle from '~features/company/CompanySectionTitle';
import EmptySalary from '~features/company/SalaryInfo/EmptySalary';
import { ISalaryInfo } from '~types/company';
import { generateUUID } from '~utils/common/uuid';
import { getSalaryRate } from '~utils/company/company';
import { millionFormattedtoString } from '~utils/formatted/number';
import { textEllipsis } from '~utils/formatted/string';

import BarGraph from '../SalaryBarGraph';
import { S } from '../style';

interface Props {
  data: ISalaryInfo[];
  companyName: string | undefined;
}

function Salary({ data, companyName }: Props) {
  const theme = useTheme();

  return (
    <S.SalaryGrpahWrapper>
      {data.map((salary) => {
        const isSalaryEmpty = Number(salary?.salary) === 0;

        const rate = getSalaryRate(
          salary.rateType === 'TOTAL' ? salary.totalRate : salary.industryRate,
        );

        const values = [Number(salary.salary), Number(salary.industry), Number(salary.total)];
        const labels = [
          textEllipsis(typeof companyName === 'string' ? companyName : '', 5),
          values[1] > 0 && salary.rateType === 'INDUSTRY' ? '업계 평균' : '',
          '전체 평균',
        ];

        return (
          <S.SalaryGraph key={generateUUID()}>
            <CompanySectionTitle>
              {salary.category === 'ALL' ? '전체 평균연봉' : '올해 입사자 평균연봉'}
              {salary.category === 'HIRED' && (
                <Tooltip
                  tooltipText={
                    '당해년도에 입사한 신입/경력직을 모두 포함한<br/>평균 연봉입니다. 국민연금은 추정값을 제공하며,<br/>금감원에 대해서는 해당 정보를 제공하지 않습니다.'
                  }
                  position='center'>
                  <ExclamationMark width={15} color={theme.colors.gray700} />
                </Tooltip>
              )}
            </CompanySectionTitle>
            {isSalaryEmpty ? (
              <EmptySalary values={values} labels={labels} />
            ) : (
              <S.GraphCard>
                <S.Title>{`${millionFormattedtoString(salary.salary)}만원`}</S.Title>
                {rate ? (
                  <S.SubTitle typography='midium150_C1'>
                    {salary.rateType === 'INDUSTRY' ? '동종업계' : '전체'}
                    <S.PointTitle>{` 연봉상위 ${rate}`}%</S.PointTitle>
                  </S.SubTitle>
                ) : (
                  <div style={{ height: '20px' }} />
                )}
                <BarGraph labels={labels} values={values} />
              </S.GraphCard>
            )}
          </S.SalaryGraph>
        );
      })}
    </S.SalaryGrpahWrapper>
  );
}

export default Salary;
